/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateOperationChainItemMutationRequest,
  UpdateOperationChainItemMutationResponse,
} from "../types/UpdateOperationChainItem.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateOperationChainItemMutationKey = () =>
  [{ url: "/v1/operation-chain/update-operation-chain-item" }] as const

export type UpdateOperationChainItemMutationKey = ReturnType<
  typeof updateOperationChainItemMutationKey
>

/**
 * {@link /v1/operation-chain/update-operation-chain-item}
 */
export async function updateOperationChainItem(
  data: UpdateOperationChainItemMutationRequest,
  config: Partial<RequestConfig<UpdateOperationChainItemMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateOperationChainItemMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateOperationChainItemMutationRequest
  >({
    method: "POST",
    url: `/v1/operation-chain/update-operation-chain-item`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateOperationChainItemMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateOperationChainItemMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateOperationChainItemMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateOperationChainItemMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateOperationChainItem(data, config)
    },
  })
}

/**
 * {@link /v1/operation-chain/update-operation-chain-item}
 */
export function useUpdateOperationChainItem<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateOperationChainItemMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateOperationChainItemMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateOperationChainItemMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateOperationChainItemMutationKey()

  const baseOptions = updateOperationChainItemMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateOperationChainItemMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateOperationChainItemMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateOperationChainItemMutationRequest },
    TContext
  >
}
